import request from 'superagent';
import Client from './Client';
import route from '../common/route-helper';

export default class PasswordApi {
  static #post(routeName, params) {
    return new Promise((resolve, reject) => {
      request.post(route(routeName))
        .accept('json')
        .send(params)
        .end((err, res) => {
          if (res?.ok) {
            resolve(res.body);
          } else {
            Client.handleErrors(res, err, reject);
          }
        });
    });
  }

  static resetPassword(params) {
    return PasswordApi.#post('api.password.reset', params);
  }

  static sendMail(params) {
    return PasswordApi.#post('api.password.sendMail', params);
  }

  static setPassword(params) {
    return PasswordApi.#post('api.password.set', params);
  }
}
